import { render, staticRenderFns } from "./CallApplication.vue?vue&type=template&id=fb683714&scoped=true"
import script from "./CallApplication.vue?vue&type=script&lang=js"
export * from "./CallApplication.vue?vue&type=script&lang=js"
import style0 from "./CallApplication.vue?vue&type=style&index=0&id=fb683714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb683714",
  null
  
)

export default component.exports